import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ROUTES } from '../../constants/routes';
import { UserCapabilities } from '../../services/auth/user-capabilities';

const BASE_ROUTE = ROUTES.STUDY;
const NAV_ITEMS = [
  {
    name: 'Estudio',
    path: ROUTES.STUDY__INFO,
    pageSectionCapability: UserCapabilities.PAGE_SECTION.STUDY,
  },
  {
    name: 'Despacho',
    path: ROUTES.STUDY__FORM,
    pageSectionCapability: UserCapabilities.PAGE_SECTION.STUDY,
  },
  {
    name: 'Historial',
    path: ROUTES.STUDY__HISTORY,
    pageSectionCapability: UserCapabilities.PAGE_SECTION.STUDY,
  },
];

@Component({
  selector: 'app-study-header',
  template: `
    <app-base-study-header
      [navItems]="filteredNavItems"
      [saveButtonDisabled]="saveButtonDisabled"
      [saveButtonLoading]="saveButtonLoading"
      [saveButtonVisible]="saveButtonVisible"
      [showInvalidMessage]="showInvalidMessage"
      (save)="save.emit($event)"
    ></app-base-study-header>
  `,
})
export class StudyHeaderContainerComponent implements OnInit {
  allNavItems: {
    name: string;
    path: string;
  }[];
  @Input() saveButtonDisabled: boolean;
  @Input() saveButtonLoading: boolean;
  @Input() saveButtonVisible: boolean;
  @Input() showDispatchButton: boolean;
  @Input() showInvalidMessage: boolean;

  @Output() save = new EventEmitter<void>();

  constructor(
    private route: ActivatedRoute,
    private userCapabilities: UserCapabilities,
  ) {}

  get filteredNavItems() {
    return (
      this.allNavItems.filter(
        (item) => item.name !== 'Despacho' || this.showDispatchButton,
      ) || []
    );
  }

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      this.allNavItems = NAV_ITEMS.filter((item) =>
        this.userCapabilities.hasSectionViewCapability(
          item.pageSectionCapability,
        ),
      ).map(({ name, path }) => ({
        name,
        path: `/${BASE_ROUTE}/${params['id']}/${path}`,
      }));
    });
  }
}
